import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getGateway, getGatewayStatistics } from '../../api/apiCalls';
import { useQuery } from '@tanstack/react-query';
import UniqueGatewayMap from '../mapComponents/uniqueGatewayMap';
import Ybar from '../charts/ybar';
import RadialBarChartComponent from '../charts/radialChart';
import DeviceHistoryChart from '../charts/line';
import { LuMapPinOff } from "react-icons/lu";

function Gateway() {
    const { id } = useParams();
    const location = useLocation();
    const server = useParams().server || location.state?.server;

    const statusObject = {
        0: 'fail',
        1: 'active',
        2: 'init',
        3: 'error'
    };

    const { data: gatewayData, isLoading: gatewayIsLoading, isError: gatewayIsError, error: gatewayError, isSuccess: gatewayIsSuccess } = useQuery({
        queryKey: ['getGateway', id, server],
        queryFn: () => getGateway(id, server),
    });

    const {
        data: gatewayStatisticsData,
        isLoading: statsIsLoading,
        isError: statsIsError,
        error: statsError,
        isSuccess: statsIsSuccess,
    } = useQuery({
        queryKey: ['getGatewayStatistics', id],
        queryFn: () => getGatewayStatistics(id),
        enabled: !!id,
    });

    useEffect(() => {
        if (gatewayIsSuccess && gatewayData?.data?.gatewayData) {
            console.log(gatewayData.data.gatewayData);
            console.log({
                latitude: gatewayData.data.gatewayData.latitude,
                longitude: gatewayData.data.gatewayData.longitude,
            });
        } else {
            console.log("gatewayData is not ready yet or doesn't have expected structure.");
        }
    }, [gatewayData, gatewayIsSuccess]);

    // Log gateway statistics data when it's successfully fetched
    useEffect(() => {
        if (statsIsSuccess && gatewayStatisticsData?.data?.statistics) {
            console.log("Gateway Statistics Data Inside:", gatewayStatisticsData.data);
            console.log(gatewayStatisticsData)
        } else {
            console.log("gatewayStatisticsData is not ready yet or doesn't have expected structure.");
        }
    }, [gatewayStatisticsData, statsIsSuccess]);

    // return (
    //     <div>
    //         <div className='flex flex-col lg:flex-row items-center justify-center mt-10 gap-10 lg:px-24'>
    //             <div className='flex flex-col w-full lg:w-[50%]'>
    //                 {gatewayIsSuccess && gatewayData?.data?.gatewayData && (
    //                     <div className='flex flex-col'>
    //                         <div className="flex flex-col text-3xl font-bold gap-4 text-[var(--textPrimary)]">
    //                             <h1>{gatewayData.data.gatewayData.name}</h1>
    //                             <h1>ID: {gatewayData.data.gatewayData.lrrid}</h1>
    //                             <h1>Status: {statusObject[gatewayData.data.gatewayData.status]?.toUpperCase()}</h1>
    //                         </div>

    //                         {gatewayIsSuccess && gatewayData?.data?.gatewayData && gatewayData?.data?.gatewayData.status === 1 &&
    //                             <div className='grid grid-cols-1 lg:grid-cols-2'>
    //                                 <div>
    //                                     <RadialBarChartComponent data={gatewayData.data.gatewayData.cpu} title={'cpu'} />
    //                                 </div>
    //                                 <div>
    //                                     <RadialBarChartComponent data={gatewayData.data.gatewayData.ram} title={'ram'} />
    //                                 </div>
    //                             </div>}

    //                     </div>
    //                 )}
    //             </div>
    //             <div className='w-full lg:w-[50%] container-outer-shadow'>
    //                 {gatewayIsSuccess && gatewayData?.data?.gatewayData && (
    //                     <MapComponent
    //                         center={[gatewayData.data.gatewayData.latitude, gatewayData.data.gatewayData.longitude]}
    //                         zoom={14}
    //                         pointer={{ latitude: gatewayData.data.gatewayData.latitude, longitude: gatewayData.data.gatewayData.longitude }}
    //                         status={gatewayData.data.gatewayData.status}
    //                     />
    //                 )}
    //             </div>
    //         </div>
    //         <div className='container-inner-shadow p-2 mt-10'>
    //             {gatewayIsSuccess && gatewayData?.data?.gatewayData && (
    //                 <div className='mt-10 text-[var(--textPrimary)] font-bold underline'>
    //                     <h1>Backhaul Status / Traffic</h1>
    //                     <Ybar ints={gatewayData.data.gatewayData.ints} />
    //                 </div>
    //             )}
    //         </div>
    //         <div className='mt-10 container-inner-shadow p-2'>
    //             <h2 className='text-[var(--textPrimary)] font-bold underline '>Gateway Power Status History</h2>
    //             {statsIsLoading ? (
    //                 <p>Loading statistics...</p>
    //             ) : statsIsError ? (
    //                 <p>Error loading statistics: {statsError?.message || 'Unknown error'}</p>
    //             ) : (
    //                 // Check if the data is in the expected structure
    //                 gatewayStatisticsData && gatewayStatisticsData.data.statistics && Array.isArray(gatewayStatisticsData.data.statistics) && gatewayStatisticsData.data.statistics.length > 0 ? (
    //                     <DeviceHistoryChart statistics={gatewayStatisticsData.data.statistics} />
    //                 ) : (
    //                     <p>No statistics available.</p> // Optional fallback if data is empty or null
    //                 )
    //             )}
    //         </div>
    //     </div>
    // );

    return (
        <div>
            <div className='flex flex-col lg:flex-row items-center justify-center mt-10 gap-10 lg:px-24'>
                <div className='flex flex-col w-full lg:w-[50%]'>
                    {gatewayIsLoading ? (
                        <div className='flex flex-col gap-4 items-center'>
                            <div className='skeleton animate-pulse h-8 w-80 bg-[var(--skeleton-bg)] rounded-md'></div>
                            <div className='skeleton animate-pulse h-8 w-60 bg-[var(--skeleton-bg)] rounded-md'></div>
                            <div className='skeleton animate-pulse h-8 w-40 bg-[var(--skeleton-bg)] rounded-md'></div>
                        </div>
                    ) : (
                        gatewayIsSuccess &&
                        gatewayData?.data?.gatewayData && (
                            <div className='flex flex-col'>
                                <div className="flex flex-col text-3xl font-bold gap-4 text-[var(--textPrimary)]">
                                    <h1>{gatewayData.data.gatewayData.name}</h1>
                                    <h1>ID: {gatewayData.data.gatewayData.lrrid}</h1>
                                    <h1>Status: {statusObject[gatewayData.data.gatewayData.status]?.toUpperCase()}</h1>
                                </div>
                                {gatewayData.data.gatewayData.status === 1 && (
                                    <div className='grid grid-cols-1 md:grid-cols-2'>
                                        <div>
                                            <RadialBarChartComponent data={gatewayData.data.gatewayData.cpu} title={'cpu'} />
                                        </div>
                                        <div>
                                            <RadialBarChartComponent data={gatewayData.data.gatewayData.ram} title={'ram'} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    )}
                </div>

                <div className="w-full lg:w-[50%] container-outer-shadow">
                    {gatewayIsLoading ? (
                        <div className="skeleton animate-pulse min-h-[500px] bg-[var(--skeleton-bg)] rounded-lg"></div>
                    ) : gatewayIsSuccess &&
                        gatewayData?.data?.gatewayData &&
                        gatewayData.data.gatewayData.latitude &&
                        gatewayData.data.gatewayData.longitude ? (
                        <UniqueGatewayMap
                            center={[
                                gatewayData.data.gatewayData.latitude,
                                gatewayData.data.gatewayData.longitude,
                            ]}
                            zoom={14}
                            pointer={{
                                latitude: gatewayData.data.gatewayData.latitude,
                                longitude: gatewayData.data.gatewayData.longitude,
                            }}
                            status={gatewayData.data.gatewayData.status}
                        />
                    ) : (
                        <div className="min-h-[500px] flex flex-col items-center justify-center text-gray-500 gap-6">
                            <div>
                                <LuMapPinOff className="text-[6rem]" />
                            </div>
                            <div>
                                <h1 className="font-bold">No coordinates available</h1>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className='container-inner-shadow p-2 mt-10'>
                {gatewayIsLoading ? (
                    <div className='skeleton animate-pulse h-[250px] w-full bg-[var(--skeleton-bg)] rounded-none'></div>
                ) : (
                    gatewayIsSuccess &&
                    gatewayData?.data?.gatewayData && gatewayData.data.gatewayData.ints ? (
                        <div className='mt-10 text-[var(--textPrimary)] font-bold underline'>
                            <h1>Backhaul Status / Traffic</h1>
                            <Ybar ints={gatewayData.data.gatewayData.ints} />
                        </div>
                    ) : (
                        <p>No Backhaul Status / Traffic data available.</p>
                    )
                )}
            </div>

            <div className='mt-10 mb-4 container-inner-shadow p-2'>
                {statsIsLoading ? (
                    <div className='skeleton animate-pulse h-[250px] w-full bg-[var(--skeleton-bg)] rounded-none'></div>
                ) : statsIsError ? (
                    <p>Error loading statistics: {statsError?.message || 'Unknown error'}</p>
                ) : (
                    gatewayStatisticsData &&
                        gatewayStatisticsData.data.statistics &&
                        Array.isArray(gatewayStatisticsData.data.statistics) &&
                        gatewayStatisticsData.data.statistics.length > 0 ? (
                        <div>
                            <h2 className='text-[var(--textPrimary)] font-bold underline'>Gateway Power Status History</h2>
                            <DeviceHistoryChart statistics={gatewayStatisticsData.data.statistics} />
                        </div>
                    ) : (
                        <p>No statistics available.</p>
                    )
                )}
            </div>
        </div>
    );
}

export default Gateway;
